module.exports = __webpack_public_path__ + "img/baby_3.0d16e854.jpg";